import { render, staticRenderFns } from "./JSysenvTabGroup.vue?vue&type=template&id=e3e79e9a&"
import script from "./JSysenvTabGroup.vue?vue&type=script&lang=js&"
export * from "./JSysenvTabGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
